import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { DEFAULT_BGN_TO_EUR_RATE } from '../../utils/currency';

interface CurrencyInfo {
  bgnToEurRate: number;
  bgnSymbol: string;
  eurSymbol: string;
}

interface CurrencyState {
  currencyInfo: CurrencyInfo | null;
  loading: boolean;
  error: string | null;
}

const initialState: CurrencyState = {
  currencyInfo: {
    bgnToEurRate: DEFAULT_BGN_TO_EUR_RATE,
    bgnSymbol: 'лв.',
    eurSymbol: '€',
  },
  loading: false,
  error: null,
};

// Async thunk to fetch currency info from backend
export const fetchCurrencyInfo = createAsyncThunk(
  'currency/fetchInfo',
  async () => {
    const response = await axios.get('/api/v1/currency/info');
    return response.data;
  }
);

const currencySlice = createSlice({
  name: 'currency',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCurrencyInfo.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCurrencyInfo.fulfilled, (state, action) => {
        state.loading = false;
        state.currencyInfo = action.payload;
      })
      .addCase(fetchCurrencyInfo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch currency info';
      });
  },
});

export default currencySlice.reducer;